import React from 'react';

import { useAppSelector } from 'js/store/hooks';

import './DownloadIframe.css';

export default function DownloadIframe() {
  const downloadUrl = useAppSelector(state => state.download.downloadUrl);

  if (!downloadUrl) return null;

  return <iframe className="DownloadIframe" title="download-iframe" src={downloadUrl} />;
}
